import { cn } from "@/lib/utils";

/**
 * Placeholder blocks for loading states. Colors must match DESIGN.md "Skeleton Colors and Theme Adherence":
 * light: bg-[#0000000f], dark: dark:bg-white/6. Do not override with bg-neutral-*, etc.
 * Includes a subtle shimmer overlay (same as loading-shimmer in globals.css) for a light sweep effect.
 *
 * Use as an empty placeholder only: pass dimensions via className (e.g. h-5 w-20). Do not pass
 * children or other markup inside Skeleton—that makes the div size to content and causes layout shift.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-[#0000000f] dark:bg-white/6 animate-pulse",
        className,
      )}
      {...props}
    >
      <span
        className="absolute inset-0 loading-shimmer rounded-[inherit] pointer-events-none"
        aria-hidden
      />
    </div>
  );
}

export { Skeleton };
